import type { VideoFrame } from '../../types';

export type BlendMode = 'source-over' | 'lighter' | 'screen' | 'overlay' | 'soft-light';

export function withOverlay(
  frame: VideoFrame,
  draw: (ctx: CanvasRenderingContext2D, w: number, h: number) => void,
  blend: BlendMode = 'lighter',
): VideoFrame {
  const canvas = document.createElement('canvas');
  canvas.width = frame.width;
  canvas.height = frame.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return frame;
  ctx.drawImage(frame.canvas as CanvasImageSource, 0, 0);
  ctx.globalCompositeOperation = blend;
  draw(ctx, frame.width, frame.height);
  ctx.globalCompositeOperation = 'source-over';
  return { width: frame.width, height: frame.height, canvas, texture: null };
}

export function withFullFrame(
  frame: VideoFrame,
  draw: (ctx: CanvasRenderingContext2D, w: number, h: number, source: CanvasImageSource) => void,
): VideoFrame {
  const canvas = document.createElement('canvas');
  canvas.width = frame.width;
  canvas.height = frame.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return frame;
  const src = frame.canvas as CanvasImageSource;
  ctx.drawImage(src, 0, 0);
  draw(ctx, frame.width, frame.height, src);
  return { width: frame.width, height: frame.height, canvas, texture: null };
}

export function stableEffectSeed(context: import('../../types').RenderContext, effectId: string): number {
  let h = context.seed;
  for (let i = 0; i < effectId.length; i += 1) {
    h = (h * 31 + effectId.charCodeAt(i)) % 1000003;
  }
  return h;
}

/** Per-frame seed for effects that intentionally vary each frame (e.g. lightning). */
export function effectSeed(context: import('../../types').RenderContext, effectId: string): number {
  return stableEffectSeed(context, effectId) + context.frameIndex * 0.01;
}
